const ProfitCalculationFormulasEnum = Object.assign({
  ACT_360: 'act/360',
  ACT_365: 'act/365',
  ACT_ACT: 'act/act',
  ACT_30_360: '30/360',
  ACT_30E_360: '30E/360',
  RENTAL_YIELD: 'rentalYield',
});

Object.freeze(ProfitCalculationFormulasEnum);

export default ProfitCalculationFormulasEnum;



// WEBPACK FOOTER //
// ./src/enum/financialProducts/ProfitCalculationFormulas.js